import axios from 'axios'
import config from '../../config';

export const SET_PRODUCT_DATA = 'SET_PRODUCT_DATA';
export const SET_ATTRIBUTES = 'SET_ATTRIBUTES';
export const UPDATE_PARAMS = 'UPDATE_URL_PARAMS';
export const SET_PREVIEW_LOADING = 'SET_PREVIEW_LOADING';
export const SET_INFO_NOTICE_WAS_SHOWN = 'SET_INFO_NOTICE_WAS_SHOWN';

export function loadProductData(productId) {
  return dispatch => {
    return axios.get(`${config.apiBase}/product-data/${productId}`)
      .then(response => response.data)
      .then(response => {
        if (response) {
          dispatch({
            type: SET_PRODUCT_DATA,
            data: response
          })
        }
        return response;
      });
  }
}

export function setAttributes(attributes) {
  return {
    type: SET_ATTRIBUTES,
    data: attributes
  };
}

export function updateParams(params, forceUpdate = false) {
  return {
    type: UPDATE_PARAMS,
    data: {
      params,
      forceUpdate
    }
  };
}

export function setPreviewLoading(value) {
  return {
    type: SET_PREVIEW_LOADING,
    data: value
  };
}

export function setInfoNoticeWasShown() {
  return {
    type: SET_INFO_NOTICE_WAS_SHOWN
  };
}
